import React from 'react';
import ReactPlayer from 'react-player';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const VideoSection = () => {
  // Video data (Replace with actual video URLs)
  const videos = [
    'https://www.youtube.com/watch?v=LPimzfOvJrI&ab_channel=NationalGeographicIndia',
    'https://youtu.be/x1548m5OEhg?si=cqyDcBx6b7mH2Wdy',
    'https://www.youtube.com/watch?v=lWBrQmYQFHA&ab_channel=NitishRajput',
    'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
  ];
  const Reviews =[
     {
    label: 'Emily Carter (USA)',
    rev: 'Incredible experience! They built our website and mobile app with flawless UI and great performance. Professional, fast, and creative!',
    rating: 5
  },
   {
    label: 'Sofia Larsson (Sweden)',
    rev: 'The team created a beautiful brand identity for us. Very responsive and detail-oriented. Would definitely work with them again.',
    rating: 4
  },
  {
    label: 'Mark Fischer (Germany)',
    rev: 'Great app development skills. The final product was smooth, scalable, and exactly what we needed. Danke!',
    rating: 5
  },
  {
    label: 'Ava Thompson (Canada)',
    rev: 'Excellent communication and on-time delivery. They handled our full digital marketing campaign and exceeded expectations.',
    rating: 5
  }
  ]
 const renderStars = (rating) => {
    const fullStars = Array.from({ length: rating }, (_, index) => <svg key={index} className="w-4 h-4 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>);
    const emptyStars = Array.from({ length: 5 - rating }, (_, index) => <svg key={index} className="w-4 h-4 text-gray-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>);
    
    return [...fullStars, ...emptyStars];
  };
  return (
    <section className="py-12 px-4 pb-0 sm:px-6 lg:px-8">
      <div className="flex flex-col flex-col-reverse lg:flex-row items-center justify-between gap-8">
        {/* Left Column - Image */}
        <div className="flex-1">
          <img
            src="../images/rb_6604.png"
            alt="Sample Image"
            className="w-full h-full max-w-[500px] m-auto"
          />
        </div>

        {/* Right Column - Card with Slider */}
        <div className="flex-1 bg-white p-6 w-full lg:w-[50%] rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-center text-gray-800 mb-6">Customer Speaks</h2>

          {/* Swiper Video Slider */}
          {/* <Swiper
            spaceBetween={20}
            slidesPerView={1}
            navigation={true}
            modules={[FreeMode, Navigation, Pagination]}
            freeMode={true}
            pagination={{ clickable: true }}
            className="swiper-container"
            style={{ position: 'relative' }}
          >
            {videos.map((videoUrl, index) => (
              <SwiperSlide key={index}>
                <div className="w-[90%]  m-auto h-[250px] md:h-[350px]">
                  <ReactPlayer
                    url={videoUrl}
                    width="100%"
                    height="100%"       
                    className="rounded"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            navigation={true}
            modules={[FreeMode, Navigation, Pagination, Autoplay]}
            freeMode={true}
            autoplay={true}
            pagination={{ clickable: true }}
            className="swiper-container"
            style={{ position: 'relative' }}
          >
            {Reviews.map((client, index) => (
              <SwiperSlide key={index}>
                <div className="w-[90%]  m-auto">
                  <figure className="max-w-screen-md mx-auto">
                    <svg
                      className="h-12 mx-auto mb-3 text-gray-400"
                      viewBox="0 0 24 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <blockquote>
                      <p className="text-xl px-4 text-center font-medium text-gray-900 md:text-2xl">
                        "{client.rev}"
                      </p>
                    </blockquote>

                    {/* Star Rating */}
                   

                    <figcaption className="flex items-center justify-center mt-2 space-x-3">
                      <div className="flex flex-col sm:flex-row items-center sm:divide-x-2 divide-gray-500">
                      {/* Rating Stars on Top (Mobile), Left (Desktop) */}
                      <div className="bg-[#1353fe] p-2 rounded-full text-sm font-light text-gray-500 mb-2 sm:mb-0 sm:order-2">
                        <div className="flex justify-center">
                          {renderStars(client.rating)}
                        </div>
                      </div>

                      {/* Client Name Below (Mobile), Right (Desktop) */}
                      <div className="sm:pr-3 font-medium text-gray-900 sm:order-1">
                        {client.label}
                      </div>
                    </div>
                    </figcaption>
                  </figure>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        
        </div>
      </div>

      {/* Custom Navigation Button Styles */}
      <style jsx>{`
        .swiper-button-next, .swiper-button-prev {
          background-color: #1353FE;
          color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 20px;
          color: white;
        }

        .swiper-pagination {
             display: flex;
            justify-content: center;
            gap: 10px;
            margin: auto;
            position: initial;
            height: 18px;
            margin-top: 10px;
        }

        .swiper-pagination-bullet {
          background-color: #1353FE;
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }

        .swiper-pagination-bullet-active {
          background-color: #1353FE;
        }
      `}</style>
    </section>
  );
};

export default VideoSection;
